const toShipmentId = require('./to-shipment-id')

const draftAdjustmentId = snapshotId => {
  const shipmentId = toShipmentId(snapshotId)
  return `_local/${shipmentId}:status:received:adjustment`
}

module.exports = draftAdjustmentId
